import { render, staticRenderFns } from "./CadCategoria.vue?vue&type=template&id=21ae2d20&"
import script from "./CadCategoria.vue?vue&type=script&lang=js&"
export * from "./CadCategoria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports